// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__2YqN3","infoBtn":"quickbooks_infoBtn__hwHv-","formBox":"quickbooks_formBox__R5YSu","formFooter":"quickbooks_formFooter__6zdBi"};